import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

import './learn_styles/learnmiddle.css';

export default function LearnMiddle() {
  return (
    <>
      <Container className='learn_middle mt-3 mb-3'>
        <Row>
          <Col>
           <div className="learn_middle_content d-flex flex-column justify-content-center align-items-center">
            <h3>LEARN</h3>
            <p>Learn everything about blockchain, Web3 and cryptocurrency</p>
           </div>
           <div className="learn_middle_content d-flex justify-content-center gap-2">
             <Button>Loream Ipsum</Button>
             <Button>Loream Ipsum</Button>
           </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}